/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualKeyPublicPem: core.serialization.ObjectSchema<
    serializers.EqualKeyPublicPem.Raw,
    Truvity.EqualKeyPublicPem
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace EqualKeyPublicPem {
    export interface Raw {
        value: string;
    }
}
